import { UUID } from '@cmg/common';
import React from 'react';

import { SidePanelSellSideNavbar } from './components/side-bar/components/design-system';
import SidePanelBuySideNavbar from './components/side-bar/SidePanelBuySideNavbar';
import { useIdentifyOrderBookPersona } from './order-book/hooks/useIdentifyOrderBookPersona';

export const OfferingSidePanelContent = ({
  offeringId,
  baseSidePanelUrl,
}: {
  offeringId: UUID;
  baseSidePanelUrl: string;
}) => {
  const { isSellSide } = useIdentifyOrderBookPersona({ offeringId });

  if (isSellSide) {
    return <SidePanelSellSideNavbar offeringId={offeringId} baseSidePanelUrl={baseSidePanelUrl} />;
  }

  return <SidePanelBuySideNavbar offeringId={offeringId} baseSidePanelUrl={baseSidePanelUrl} />;
};
